import { render, staticRenderFns } from "./SelectMenu.vue?vue&type=template&id=976f8bc2&scoped=true"
import script from "./SelectMenu.vue?vue&type=script&lang=js"
export * from "./SelectMenu.vue?vue&type=script&lang=js"
import style0 from "./SelectMenu.vue?vue&type=style&index=0&id=976f8bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976f8bc2",
  null
  
)

export default component.exports